import { Flex } from 'common/src/designSystem/components/flex';
import * as React from 'react';
import { useTeamRightPanelContext } from './teamRightPanelContext';
import { TeamRightPanelPositionSlot } from './teamRightPanelPositionSlot';

export const TeamRightPanelPositionsSlots = () => {
    const { allSlots } = useTeamRightPanelContext();

    return (
        <Flex direction="column" gap="3" width={1}>
            {allSlots.map((slot) => (
                <TeamRightPanelPositionSlot key={slot.id} slot={slot} />
            ))}
        </Flex>
    );
};
